const formatCurrency = (value) => {
    return `${Number(value || 0).toFixed(2)} €`;
};

const formatDate = (dateString) => {
    if (!dateString) return "";

    const normalized = typeof dateString === "string"
        ? dateString.replace(" ", "T")
        : dateString;

    const date = new Date(normalized);

    if (Number.isNaN(date.getTime())) return dateString;

    return date.toLocaleDateString("el-GR");
};

const getPaymentMethodLabel = (value) => {
    switch (String(value)) {
        case "1":
            return "Αντικαταβολή";
        case "2":
            return "Κατάθεση";
        case "3":
            return "Πιστωτική κάρτα";
        default:
            return "";
    }
};

const buildAddressLines = ({
                               name = "",
                               address = "",
                               zipCode = "",
                               city = "",
                               country = "Greece",
                               phone = "",
                               mobile = "",
                           }) => {
    return [name, address, `${zipCode} ${city}`.trim(), country, phone, mobile].filter(Boolean);
};

export const normalizeOrderDetails = (data, language = "el") => {
    const items = data?.data?.items || [];
    const order = data?.data?.order || {};

    const totalItems = items.reduce((sum, item) => sum + Number(item?.quantity || 0), 0);

    const orderHeader = {
        orderNumber: order?.orderNumber || "",
        orderDate: formatDate(order?.createDt),
        orderTotal: `${formatCurrency(order?.total)} (${totalItems} items)`,
        paymentMethod: getPaymentMethodLabel(order?.payment),
    };

    const orderItems = items.map((item) => ({
        id: item?.id || "",
        image: item?.image || "",
        quantityLabel: `${Number(item?.quantity || 0)}x`,
        sku: item?.code ? `ΚΩΔΙΚΟΣ: ${item.code}` : "",
        name:
            language === "en"
                ? (item?.nameEN || item?.nameEL || "")
                : (item?.nameEL || item?.nameEN || ""),
        price: formatCurrency(item?.price),
    }));

    const orderTotals = {
        subtotal: formatCurrency(order?.subtotal),
        tax: formatCurrency(order?.tax),
        shipping: formatCurrency(order?.shipping),
        paymentMethodLabel: "Τρόπος πληρωμής",
        paymentMethodValue: getPaymentMethodLabel(order?.payment),
        total: formatCurrency(order?.total),
    };

    const addresses = {
        shipping: {
            title: "ΣΤΟΙΧΕΙΑ ΠΑΡΑΛΑΒΗΣ",
            lines: buildAddressLines({
                name: order?.CarrierName,
                address: order?.CarrierAddress,
                zipCode: order?.CarrierZipCode,
                city: order?.CarrierCity,
                phone: order?.CarrierPhone,
                mobile: "",
            }),
        },
        billing: {
            title: "ΣΤΟΙΧΕΙΑ ΤΙΜΟΛΟΓΙΟΥ",
            lines: buildAddressLines({
                //name: order?.CarrierName,
                address: order?.Address,
                zipCode: order?.ZipCode,
                city: order?.City,
                phone: order?.AddrPhone,
                mobile: "",
            }),
        },
        transport: {
            title: "ΜΕΤΑΦΟΡΙΚΗ",
            lines: [
                order?.CarrierName,
                order?.CarrierAddress,
                `${order?.CarrierZipCode || ""} ${order?.CarrierCity || ""}`.trim(),
                order?.CarrierPhone,
                order?.CarrierEmail,
            ].filter(Boolean),
        },
    };

    const extraInfoText = "";

    return {
        orderHeader,
        orderItems,
        orderTotals,
        extraInfoText,
        addresses,
        raw: data,
    };
};